import { render, staticRenderFns } from "./RelateOrder.vue?vue&type=template&id=ee1dec76&scoped=true"
import script from "./RelateOrder.vue?vue&type=script&lang=js"
export * from "./RelateOrder.vue?vue&type=script&lang=js"
import style0 from "./RelateOrder.vue?vue&type=style&index=0&id=ee1dec76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1dec76",
  null
  
)

export default component.exports